import utility from "../utility.js"
import { Auth } from "./../auth.js"

//予約操作
export class BookingController {
    constructor(apiRootPath){
        apiRootPath ??= window.Setting.api
        this.url = apiRootPath + "booking" 
    }

    /** GET slot/state/list */
    async getSlotStateList(start, end){
        let res = await Auth.ajax({
            url: `${this.url}/slot/state/list?start=${start.getTime()/1000}&end=${end.getTime()/1000}`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
            res.data.forEach(r=>r.bookingDate = new Date(r.bookingDate * 1000))
        }
        return res
    }
    /** PUT slot/:slotId/count */
    async setSlotCount(slotId, count, reserveNewSlot){
        let res = await Auth.ajax({
            method: "PUT",
            url: `${this.url}/slot/${slotId}/count?value=${count}&reserveNewSlot=${reserveNewSlot}`
        })
        return res
    }
    /** DELETE slot/:slotId/reserved */
    async releaseReserved(slotId){
        let res = await Auth.ajax({
            method: "DELETE",
            url: `${this.url}/slot/${slotId}/reserved`
        })
        return res
    }
    /** POST slot/:slotId/reserved */
    async createReserved(slotId){
        let res = await Auth.ajax({
            method: "POST",
            url: `${this.url}/slot/${slotId}/reserved`
        })
        return res
    }

    /** GET facility/block */
    async getFacilityBlock(){
        let res = await Auth.ajax({
            url: `${this.url}/facility/block`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
            res.data.forEach(r=>r.blockStart = r.blockStart == null ? null : new Date(r.blockStart * 1000))
            res.data.forEach(r=>r.blockEnd = r.blockEnd == null ? null : new Date(r.blockEnd * 1000))
        }
        return res
    }
    /** POST facility/:facilityId/block */
    async setFacilityBlock(facilityId, blockStart, blockEnd){
        return await Auth.ajax({
            method: "POST",
            url: `${this.url}/facility/${facilityId}/block?start=${blockStart.getTime()/1000}&end=${blockEnd.getTime()/1000}`,
        })
    }
    /** DELETE facility/:facilityId/block */
    async deleteFacilityBlock(facilityId){
        return await Auth.ajax({
            method: "DELETE",
            url: `${this.url}/facility/${facilityId}/block`,
        })
    }

    /** GET unapproved */
    async getUnapprovedList(){
        let res = await Auth.ajax({
            url: `${this.url}/unapproved`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
            res.data.forEach(x=>{
                x.bookingDate = new Date(x.bookingDate * 1000)
                x.updateOn = new Date(x.updateOn * 1000)
            })
        }
        return res
    }
    
    /** GET overview */
    async getOverview(start, end, facilityId, detail){
        let res = await Auth.ajax({
            url: `${this.url}/overview`
                 + `?start=${start.getTime()/1000}&end=${end.getTime()/1000}&facilityId=${facilityId}&detail=${detail ?? true}`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
            res.data.forEach(x=>{
                x.bookingDate = new Date(x.bookingDate * 1000)
                x.bookings.forEach(y=>{
                    y.bookingDate = new Date(y.bookingDate * 1000)
                    y.updateOn = new Date(y.updateOn * 1000)
                })
            })
        }
        return res
    }
    
    /** POST search */
    async search(parameter){
        let obj = {}
        Object.keys(parameter).forEach(k=>{
            obj[k] = parameter[k]
            if(obj[k] instanceof Date) obj[k] = obj[k].getTime() / 1000
        })
        let res = await Auth.ajax({
            method: "POST",
            url: `${this.url}/search`,
            body: obj,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
            res.data.forEach(x=>{
                x.bookingDate = new Date(x.bookingDate * 1000)
                x.updateOn = new Date(x.updateOn * 1000)
                x.infoDeathDate = new Date(x.infoDeathDate * 1000)
            })
        }
        return res
    }
    
    /** POST search/csv */
    async searchCsv(parameter){
        let obj = {}
        Object.keys(parameter).forEach(k=>{
            obj[k] = parameter[k]
            if(obj[k] instanceof Date) obj[k] = obj[k].getTime() / 1000
        })
        return await Auth.ajax({
            method: "POST",
            url: `${this.url}/search/csv`,
            body: obj,
            responseType: "blob",
        })
    }

    /** POST|DELETE :bookingId/approved */
    async setApproved(bookingId, approved){
        return await Auth.ajax({
            method: approved ? "POST" : "DELETE",
            url: `${this.url}/${bookingId}/approved`
        })
    }
    
    /** GET :bookingId/detail */
    async getDetail(bookingId){
        let res = await Auth.ajax({
            url: `${this.url}/${bookingId}/detail`
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
            res.data.bookingDate = new Date(res.data.bookingDate * 1000)
            res.data.createOn = new Date(res.data.createOn * 1000)
            res.data.updateOn = new Date(res.data.updateOn * 1000)
            res.data.infoBarthDate = utility.fromEpocSec(res.data.infoBarthDate)
            res.data.infoDeathDate = utility.fromEpocSec(res.data.infoDeathDate)
            res.data.useFacility2Start = new Date(res.data.useFacility2Start * 1000)
            res.data.useFacility2End = new Date(res.data.useFacility2End * 1000)
            res.data.receiptDate = new Date(res.data.receiptDate * 1000)
        }
        return res
    }

    /** GET :bookingId/image/:name */
    async getImageData(bookingId, name){
        var res = await Auth.ajax({
            url: `${this.url}/${bookingId}/image/${name}`,
            responseType: "blob",
        })
        if(res.ok) res.data = res.body
        return res
    }

    /** POST create */
    async create(data){
        let obj = {}
        Object.assign(obj, data)
        obj.bookingDate = obj.bookingDate.getTime() / 1000
        obj.createOn = 0
        obj.updateOn = 0
        obj.infoBarthDate = utility.toEpochSec(obj.infoBarthDate)
        obj.infoDeathDate = utility.toEpochSec(obj.infoDeathDate)
        obj.useFacility2Start = obj.useFacility2Start.getTime() / 1000
        obj.useFacility2End = obj.useFacility2End.getTime() / 1000
        obj.receiptDate = obj.receiptDate.getTime() / 1000

        return await Auth.ajax({
            method: "POST",
            url: `${this.url}/create`,
            body: obj
        })
    }

    /** POST update */
    async update(data){
        let obj = {}
        Object.assign(obj, data)
        obj.bookingDate = obj.bookingDate.getTime() / 1000
        obj.createOn = 0
        obj.updateOn = 0
        obj.infoBarthDate = utility.toEpochSec(obj.infoBarthDate)
        obj.infoDeathDate = utility.toEpochSec(obj.infoDeathDate)
        obj.useFacility2Start = obj.useFacility2Start.getTime() / 1000
        obj.useFacility2End = obj.useFacility2End.getTime() / 1000
        obj.receiptDate = obj.receiptDate.getTime() / 1000

        return await Auth.ajax({
            method: "POST",
            url: `${this.url}/update`,
            body: obj
        })
    }

    /** POST :bookingId/cancel */
    async cancel(bookingId){
        return await Auth.ajax({
            method: "POST",
            url: `${this.url}/${bookingId}/cancel`
        })
    }

    /** DELETE :bookingId */
    async delete(bookingId, targetState){
        return await Auth.ajax({
            method: "DELETE",
            url: `${this.url}/${bookingId}?targetState=${targetState ?? 0}`
        })
    }
}